import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from "axios";
import Cookies from "universal-cookie";

const headersdata = {
    "content-type": "application/json",
    Accept: "application/json",
    get Authorization() {
        const cook = new Cookies().get("loginData1");
        return cook != undefined ? cook.accessToken : "";
    }
};

export const callPostAxios = (URL, data, errorIn) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(URL, data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    console.error(err);
                    reject(`Error in ${errorIn} axios!`);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const callGetAxios = (URL, errorIn, signal, params) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(URL, { headers: headersdata, signal })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    if (err.message === "canceled") {
                        return;
                    }
                    reject(`Error in ${errorIn} axios!`);
                });
        } catch (error) {
            console.error(error)
            console.error(`in LoginService > ${errorIn}, Err===`, error);
            reject(SYSTEM_ERROR);
        }
    });
};

export const callPutAxios = (URL, data, errorIn, errorMessage) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .put(URL, data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(`Error in ${errorIn} axios!`);
                });
        } catch (error) {
            console.error(errorMessage, error);
            reject(SYSTEM_ERROR);
        }
    });
};

const handleSuccess = (result, successCallBack) => {
    if (successCallBack != null) {
        if (result.data.errorCode === 997) {
            const cookies = new Cookies();
            cookies.remove("authToken");
            cookies.remove("user");
            window.location.href = "/";
            return;
        }
        // if (result.data.errorCode !== 0) {
        //     return;
        // }
        // NOTE > If we need to handle any other code, add here.
        successCallBack(result.data);
    }
};

const handleFailure = (error, failedCallBack) => {
    if (failedCallBack != null) {
        failedCallBack(error);
        return;
    }
};


export const callPostApi = (
    url,
    data,
    headerMap,
    successCallBack,
    failedCallBack
) => {

    axios
        .post(url, data, {
            headers: headersdata,
        })
        .then((result) => handleSuccess(result, successCallBack))
        .catch((error) => handleFailure(error, failedCallBack));
};

// export const callDeleteAxios = (URL, data, errorIn, errorMessage) => {
//     return new Promise((resolve, reject) => {
//         try {
//             axios
//                 .delete(WAREHOUSE_URL() + uuid, { headers: headersdata })
//                 .then((res) => {
//                     resolve(res.data);
//                 })
//                 .catch((err) => {
//                     reject("Error in deleteWarehouse axios!");
//                 });
//         } catch (error) {
//             console.error("in LoginService > deleteWarehouse, Err===", error);
//             reject(SYSTEM_ERROR);
//         }
//     });
// };